export default __webpack_public_path__ + "assets/images/g-list-before-94c7cfd8.png";